import { render } from "./ProjectTermsOfServiceView.vue?vue&type=template&id=5b2c4dc6"
import script from "./ProjectTermsOfServiceView.vue?vue&type=script&lang=js"
export * from "./ProjectTermsOfServiceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__